import actions from "@/core/store/modules/generic/actions";
import getters from "@/core/store/modules/generic/getters";
import mutations from "@/core/store/modules/generic/mutations";

export default {
    state: {
        waiting: {},
        deleteDialog: {},
        countries: []
    },
    getters,
    mutations,
    actions
}